import * as constants from '../constants/user.constants';
import { AppDispatch, RootState } from '../store';

export const setUserData = (payload: any) => (dispatch: AppDispatch) => {
  dispatch({ type: constants.USER_DATA, payload });
};

export const setUserLogout = () => (dispatch: AppDispatch) => {
  dispatch({ type: constants.USER_LOGOUT });
};

export const setCartData =
  (
    selectedDate: any | null,
    selectedTime?: any | null,
    selectedTickets?: any | null,
    eventId?: string,
  ) =>
    (dispatch: AppDispatch) => {
      dispatch({
        type: constants.CART_DATA,
        payload: { selectedDate, selectedTime, selectedTickets, eventId },
      });
    };

export const removeCartData =
  (payload: string) => (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();
    const selectedTickets = state?.user?.cart?.selectedTickets || {};

    // Convert selectedTickets object to array and filter out the payload
    const updatedCartArray = Object.values(selectedTickets).filter(
      (ticket: any) => ticket.code !== payload,
    );

    // Convert array back to object using ticket.code as the key
    const updatedCartObject = updatedCartArray.reduce(
      (acc: Record<string, any>, ticket: any) => {
        acc[ticket.code] = ticket;
        return acc;
      },
      {},
    );

    // Dispatch the updated cart object
    dispatch({
      type: constants.CART_DATA,
      payload: {
        selectedTickets: updatedCartObject,
        selectedDate: state?.user?.cart?.selectedDate,
        selectedTime: state?.user?.cart?.selectedTime,
      },
    });
  };
